import apiClient from './apiClient';
import {
  Domain,
  DomainWithDetails,
  DomainCreateAPI,
  DomainUpdate,
  DomainMember,
  DomainStats,
} from '../types';

const apiBaseURL = '/domains/';

export const domainService = {
  // Get all domains for current user
  async getUserDomains(): Promise<Domain[]> {
    const response = await apiClient.get(apiBaseURL);
    return response.data;
  },

  // Get domains for a specific organization
  async getOrganizationDomains(organizationId: string): Promise<Domain[]> {
    const response = await apiClient.get(`${apiBaseURL}organization/${organizationId}`);
    return response.data;
  },

  // Get domain by ID with details
  async getDomainDetails(domainId: string): Promise<DomainWithDetails> {
    const response = await apiClient.get(`${apiBaseURL}${domainId}`);
    return response.data;
  },

  // Create a new domain
  async createDomain(domain: DomainCreateAPI): Promise<Domain> {
    const response = await apiClient.post(apiBaseURL, domain);
    return response.data;
  },

  // Update domain
  async updateDomain(domainId: string, domain: DomainUpdate): Promise<Domain> {
    const response = await apiClient.put(`${apiBaseURL}${domainId}`, domain);
    return response.data;
  },

  // Delete domain
  async deleteDomain(domainId: string): Promise<void> {
    await apiClient.delete(`${apiBaseURL}${domainId}`);
  },

  // Get domain members (now returns all organization members)
  async getDomainMembers(domainId: string): Promise<DomainMember[]> {
    const response = await apiClient.get(`${apiBaseURL}${domainId}/members`);
    return response.data;
  },

  // DEPRECATED: Add member to domain - no longer needed as all organization members have access
  async addDomainMember(domainId: string, userId: string, role: 'admin' | 'member' | 'viewer' = 'member'): Promise<void> {
    await apiClient.post(`${apiBaseURL}${domainId}/members`, {
      user_id: userId,
      role: role,
    });
  },

  // DEPRECATED: Remove member from domain - no longer needed as all organization members have access
  async removeDomainMember(domainId: string, userId: string): Promise<void> {
    await apiClient.delete(`${apiBaseURL}${domainId}/members/${userId}`);
  },

  // DEPRECATED: Update member role - no longer needed as all organization members have access
  async updateMemberRole(domainId: string, userId: string, role: 'admin' | 'member' | 'viewer'): Promise<void> {
    await apiClient.put(`${apiBaseURL}${domainId}/members/${userId}/role`, null, {
      params: { role }
    });
  },

  // Get domain statistics
  async getDomainStats(domainId: string): Promise<DomainStats> {
    const response = await apiClient.get(`${apiBaseURL}${domainId}/stats`);
    return response.data;
  },

  // Folders for a domain (from MinIO)
  async listDomainFolders(domainId: string, prefix?: string) {
    const params = prefix ? { prefix } : undefined;
    const response = await apiClient.get(`${apiBaseURL}${domainId}/folders/`, { params });
    return response.data;
  },
};

export default domainService;
